import {
  number,
  object,
  string,
} from 'yup';

import MESSAGE from '../../constants/messages';

export const complaintFormSchema = object().shape({
  CausasId: number()
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  EstadosId: number()
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  MedioId: number()
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  NivelATId: number()
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  PenalizacionId: number()
    .oneOf([1, 2, 3], MESSAGE.TYPE_ERROR_NUMBER)
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  product: string()
    .required(MESSAGE.REQUIRED),
  QuejasColId: number()
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  QuejasCP: number()
    .max(99999, MESSAGE.MAX_LENGTH)
    .min(1, MESSAGE.MIN_LENGTH)
    .required(MESSAGE.REQUIRED),
  QuejasEdad: number()
    .integer(MESSAGE.INTEGER)
    .positive(MESSAGE.POSITIVE)
    .when('QuejasTipoPersona', {
      is: 1,
      then: number()
        .typeError(MESSAGE.REQUIRED)
        .required(MESSAGE.REQUIRED),
    }),
  QuejasEstatus: number()
    .oneOf([1, 2])
    .required(MESSAGE.REQUIRED),
  QuejasFolio: string()
    .uppercase()
    .max(50, MESSAGE.MAX_LENGTH)
    .required(MESSAGE.REQUIRED),
  QuejasLocId: number()
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  QuejasMunId: number()
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  QuejasNoTrim: number()
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  QuejasPORI: string()
    .oneOf(['SI', 'NO'], MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
  QuejasRespuesta: number()
    .oneOf([1, 2, 3], MESSAGE.TYPE_ERROR_NUMBER)
    .when('QuejasEstatus', {
      is: 2,
      then: number().required(MESSAGE.REQUIRED),
    }),
  QuejasSexo: string()
    .oneOf(['H', 'M'], MESSAGE.TYPE_ERROR_NUMBER)
    .when('QuejasTipoPersona', {
      is: 1,
      then: string().required(MESSAGE.REQUIRED),
    }),
  QuejasTipoPersona: number()
    .oneOf([1, 2])
    .typeError(MESSAGE.TYPE_ERROR_NUMBER)
    .required(MESSAGE.REQUIRED),
});
